import {useDebugValue} from 'react';

import {getNoUndefObject} from '../../../utils';

function useOptions(defaultOptions, ...otherOptions) {
    const specifiedOptions = otherOptions.reduce((accumulatedOptions, currentOptions) => ({
        ...accumulatedOptions,
        ...getNoUndefObject(currentOptions)
    }), {});

    const options = {
        ...defaultOptions,
        ...specifiedOptions
    };

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useOptions};
